import { useState, useRef } from "react";

import styles from "./CodeInput.module.css";

function CodeInput({ length = 6, onChange }) {
	const [values, setValues] = useState(Array(length).fill(""));
	const refs = useRef([]);

	const handleChange = (value, index) => {
		if (!/^[0-9]?$/.test(value)) return; // apenas dígitos

		const newValues = [...values];
		newValues[index] = value;
		setValues(newValues);

		if (value && index < length - 1) {
			refs.current[index + 1].focus();
		}

		onChange && onChange(newValues.join(""));
	};

	const handleKeyDown = (e, index) => {
		if (e.key === "Backspace" && !values[index] && index > 0) {
			refs.current[index - 1].focus();
		}
	};

	return (
		<div className={styles.container}>
			{values.map((v, i) => (
				<input
					key={i}
					ref={(el) => (refs.current[i] = el)}
					type="text"
					maxLength={1}
					value={v}
					onChange={(e) => handleChange(e.target.value, i)}
					onKeyDown={(e) => handleKeyDown(e, i)}
					className={styles.input}
				/>
			))}
		</div>
	);
}

export default CodeInput;
